import { render } from "./TheFaq.vue?vue&type=template&id=a75690ca"
import script from "./TheFaq.vue?vue&type=script&lang=js"
export * from "./TheFaq.vue?vue&type=script&lang=js"
script.render = render

export default script